import Notifications              from 'scripts/defa/notifications/collection-notifications';
import NotificationsDeleteForm    from 'scripts/defa/notifications/view-notifications-delete-form';
import NotificationCollectionView from 'scripts/defa/notifications/view-notification-collection-view';
import { NotificationContainer }  from 'scripts/defa/notifications/view-notifications-container';
import ControlModule              from 'scripts/poppet/control-module';
import template                   from 'templates/controlNotifications.jst.html';
import { T }                      from 'defa-object';

/**
 * defa.views.ControlNotificationsView
 * A control module for unit notifications.
 * @version 1.3.0
 */

const selectors = {
	contextHeader      : '[data-text=context-header]',
	toggleButton       : '[data-toggle=expand-spoiler]',
	navButtons         : '[data-click^=nav-]',
	regionNotifications: '[data-region=notifications]',
	regionContainer    : '[data-region=container]',
};

const ControlNotificationsView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:notifications',
	compressedNavState: 'unit:control:overview',
	
	className: function () {
		return this._getClassName( 'control-notifications' );
	},
	
	ui: {
		header: selectors.contextHeader,
		nav   : selectors.navButtons,
		toggle: selectors.toggleButton,
		sticky: selectors.regionNotifications,
	},
	
	regions: {
		notifications: selectors.regionNotifications,
		container    : selectors.regionContainer
	},
	
	events: {
		'click @ui.toggle': 'onClickToggle', // super
		'click @ui.nav'   : 'onClickNav',
	},
	
	childViewEvents: {
		'update:header'    : 'updateHeader',
		'clear:collection' : 'clearCollection',
		'show:read'        : 'fetchReadNotifications'
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onRender: function () {
		this._setStickyHidden( this.options.hideSticky );
		this._showNotifications( this.options.hideSticky );
	},
	
	onClickToggle( event ) {
		ControlModule.prototype.onClickToggle.call( this, event );
		this._setStickyHidden( this.isOpen() );
		this._showNotifications( false );
	},
	
	/**
	 * Updates the header depending on which view is showing
	 * @void
	 */
	updateHeader: function( headerContext ){
		let header = this.getUI('header');
		switch ( headerContext ) {
			case 'recipients':
				header.html(T.tc("ControlNotifications","Recipients"));
				break;
			case 'all':
				header.html(T.tc("ControlNotifications","All Notifications"));
				break;
			case 'deleteAll':
				header.html(T.tc("ControlNotifications","All Notifications"));
				break;
			case 'unread':
			default:
				header.html(T.tc("ControlNotifications","Notifications"));
				break;
		}
	},
	
	/**
	 * Triggers when the collectionview Triggers read
	 * @void
	 */
	onChildviewRead: function( notification, read) {
		if(this.model.get('useBackendApi')) {
			notification.markAsReadCheck(read);
		} else {
			this.model.trigger('mark:as:read', notification.id, read, this.model.get( 'id' ));
		}
	},

	onChildviewDelete: function( notification ){
		if(this.model.get('useBackendApi')) {
			notification.destroy();
		} else {
			this.model.trigger('delete:notification', notification.id, this.model.get( 'id' ));
		}
	},

	onChildviewDeleteAll: function( notifications ) {
		if(this.model.get('useBackendApi')) {
			this._showDeleteNotifications(notifications);
		} else {
			this.model.trigger('delete:all', this.model.get('id'));
		}
	},

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	isOpen: function() {
		return this.ui.toggle.hasClass( 'open' )
	},
	
	
	onChildviewCancel: function(){
		this._showAllNotifications();
	},
	
	_showDeleteNotifications: function(notifications){
		let self = this;
		let notificationContainer = new NotificationContainer( _.extend( this.options, {
			closeLink: false,
			view     : 'deleteAll',
			model    : this.model
		} ) );
		this.showChildView( 'container', notificationContainer, false );
	},
	
	_showNotifications: function ( showContainer ) {
		if ( this.isOpen() || showContainer) {
			this._showNotificationContainer();
		} else {
			this._showUnreadNotifications();
		}
	},

	_showUnreadNotifications: function () {
		this.updateHeader('unread');
		this.model.set('getUnread', true);
		let notificationCollectionView = new NotificationCollectionView( {
			collection: this._unreadNotifications(),
		} );
		notificationCollectionView.setMaxCount( 3 );
		notificationCollectionView.unread = true;

		//Unread notifications...
		this.showChildView( 'notifications', notificationCollectionView );
	},

	_showNotificationContainer: function() {
		// The menu: (show notifications, show recepients...)
		let view = this.model.get('useBackendApi') ? 'menu' : 'all';
		let notificationContainer = new NotificationContainer( _.extend( this.options, {
			closeLink: false,
			view     : view,
			model    : this.model
		} ) );
		this.showChildView( 'container', notificationContainer, false );
	},
	
	_showAllNotifications: function () {
		let notificationContainer = new NotificationContainer( _.extend( this.options, {
			closeLink: false,
			view     : 'all',
			model    : this.model
		} ) );
		this.showChildView( 'container', notificationContainer, false );
	},

	_setStickyHidden( hidden ) {
		this.ui.sticky.toggleClass( 'hidden', hidden );
	},

	// TODO! Check if these mthods are used in native or could be removed
	_unreadNotifications: function() {
		if(!this.unread) {
			return new Notifications(this.model.get('unreadNotifications'));		}
	},

	_readNotifications: function() {
		if(!this.unread) {
			return new Notifications(this.model.get('readNotifications'));
		}
	}
	
} );

export default ControlNotificationsView;
